export class Options {
  _schema = {};

  _query = {
    size: "posterSize",
    frame: "posterFrame",
    giftwrap: "posterGiftwrapSelect",
    dayLabel: "DayLabel",
    monthLabel: "MonthLabel",
    yearLabel: "YearLabel",
    eventLabel: "EventLabel",
    namesLabel: "NamesLabel",
    posterColorNumber: "PosterColorNumber",
    previousCartItemId: "previousCartItemId",
    printType: "PrintType",
    aluminiumColor: "AluminiumColor",
  };

  _options = {
    settingsPanel: "map",
    posterSize: "small",
    posterFrame: "black",
    acrylBlock: "no-block",
  };

  constructor() {
    this._searchParams = new URLSearchParams(window.location.search);
    // Flips the queries key and value
    this._queryMap = Object.assign(
      {},
      ...Object.entries(this._query).map(([a, b]) => ({ [b]: a }))
    );
  }

  checkEncodeURI(str) {
    return /\%/i.test(str);
  }

  get(key, defaultValue = null, defaultType = null) {
    let type = this._schema[key] || defaultType;
    let value = this._getOption(key) || defaultValue;

    if (!type) {
      return value || defaultValue;
    }

    if (type === "object" && value) {
      if (this.checkEncodeURI(value)) {
        value = decodeURI(value);
      }

      return JSON.parse(value);
    }

    if (type === "split" && value) {
      return value.replace("[", "").replace("]", "").split(",");
    }

    if (type === "bool") {
      if (value === "true" || value === "1" || value === true) {
        return true;
      }

      if (value === "false" || value === "0" || value === false) {
        return false;
      }

      return this._options[key];
    }

    return value;
  }

  _getOption(key) {
    let value;
    let altKey = this._queryMap[key];

    // Try GET parameters
    value = this._searchParams.get(key);
    if (value !== null) return value;

    // Try GET parameters with custom name
    value = this._searchParams.get(altKey);
    if (value !== null) return value;

    // Try Local storage
    value = localStorage.getItem(key);
    if (value !== null) return value;

    // Return default value
    return this._options[key] || this._options[altKey];
  }

  _getQuery() {}

  all() {
    return this._options;
  }
}
